export default "__VITE_ASSET__fxS_aNOk__"